/**
 * iter75 Phase 3 — Property Management Hub tab registry.
 */
import {
  Briefcase, Building, Building2, UserCog, ClipboardList, BarChart3, Cog, TrendingUp,
} from 'lucide-react';

const ADMIN_TIER = new Set(['super_admin', 'admin']);
const ALL_INTERNAL = new Set([...ADMIN_TIER, 'service_manager', 'construction_manager', 'office_staff', 'manager']);

export const PM_HUB_BASE = '/admin/pm';

export const PM_TABS = [
  { key: 'companies',         label: 'Companies',         icon: Briefcase,     path: '/admin/pm/companies',         allow: ALL_INTERNAL },
  { key: 'properties',        label: 'Properties',        icon: Building,      path: '/admin/pm/properties',        allow: ALL_INTERNAL },
  { key: 'property-requests', label: 'Property Requests', icon: Building2,     path: '/admin/pm/property-requests', allow: ALL_INTERNAL },
  { key: 'accounts',          label: 'Portal Accounts',   icon: UserCog,       path: '/admin/pm/accounts',          allow: ADMIN_TIER },
  { key: 'service-requests',  label: 'PM Service Requests', icon: ClipboardList, path: '/admin/pm/service-requests', allow: ALL_INTERNAL },
  { key: 'po-reports',        label: 'PO Reports',        icon: BarChart3,     path: '/admin/pm/po-reports',        allow: ALL_INTERNAL },
  { key: 'assets',            label: 'Asset Tracking',    icon: Cog,           path: '/admin/pm/assets',            allow: ALL_INTERNAL },
  { key: 'crm',               label: 'CRM · Prospects',   icon: TrendingUp,    path: '/admin/pm/crm',               allow: ALL_INTERNAL },
];

// Old `/admin/pm/*` URLs route to the same pages as before, but we redirect anything that
// previously bypassed the hub (none currently — entries kept for symmetry with other hubs).
export const PM_LEGACY_REDIRECTS = [];
